<template>
  <context-bar-and-content class="pay-referral">
    <template slot="context-bar-left">
      <strong>PAY REFERRAL BONUS</strong>
    </template>
    <template slot="context-bar-right">
      &nbsp;
    </template>
    <el-row class="find-client" justify="center" :gutter="0">
      <el-col :span="24">
        <h2 class="align-center">Payout Refer-A-Friend Bonus</h2>
      </el-col>
      <el-col class="ssn-or-upload-wrapper" :lg="{ span: 20, offset: 2 }">
        <el-col :span="FeatureFlag.B2B_RAT ? 12 : 24" class="pa-3">
          <h2>Enter the Referring Client's SSN</h2>
          <el-alert class="mb-3" :title="clientNotFoundError" type="error" show-icon
            v-if="clientNotFoundError"></el-alert>
          <el-row :gutter="18">
            <el-col :span="24">
              <find-client-by-ssn @clientFound="onClientFound" @clientNotFound="onClientNotFound"
                @searchStarted="onSearchStarted"></find-client-by-ssn>
            </el-col>
          </el-row>
        </el-col>
        <el-col v-if="FeatureFlag.B2B_RAF" :span="12" class="pa-3">
          <h2>Select a Business</h2>
          <el-row :gutter="18">
            <el-col :span="24">
              <business-selector @businessSelected="onBusinessSelected" />
            </el-col>
          </el-row>
        </el-col>
      </el-col>
    </el-row>
  </context-bar-and-content>
</template>

<script>
import ContextBarAndContent from '@/components/layout/ContextBarAndContent.vue';
import FindClientBySsn from '@/components/widgets/FindClientBySSN.vue';
import BusinessSelector from '@/components/widgets/BusinessSelector.vue';
import FeatureFlag from '@/util/FeatureFlag';

export default {
  name: 'pay-referral',
  data() {
    return {
      FeatureFlag,
      clientNotFoundError: null,
      errorMessage: null,
    };
  },
  methods: {
    onSearchStarted() {
      this.clientNotFoundError = null;
    },
    onClientFound(clientId) {
      this.$router.push({
        name: 'payClientReferral',
        params: {
          entityId: clientId,
        },
      });
    },
    onClientNotFound(ssn) {
      this.clientNotFoundError = `No client found with SSN: ${ssn}`;
    },
    onBusinessSelected(business) {
      this.$router.push({
        name: 'payBusinessReferral',
        params: {
          entityId: business.id,
        },
      });
    },
  },
  components: {
    ContextBarAndContent,
    FindClientBySsn,
    BusinessSelector,
  },
};

</script>

<style lang="scss">
.pay-referral {
  .ssn-or-upload-wrapper {
    background: #F2F2F2;
    border-radius: 20px;

    >.el-col:not(:first-child) {
      border-left: 1px solid #CCC;
    }
  }

  .client-header {
    h2 {
      margin: 0;
      padding: 0 5px;
      font-size: 1.8em;

      span {
        font-weight: normal;
        color: #999;
        font-size: 0.75em;
        text-transform: uppercase;
      }
    }
  }

  .main-section {
    width: calc(100% - 18px);
  }
}
</style>
